// Component copy to DateTimePickers.web.tsx and DateTimePickers.tsx on create-scheduled-tournament
import React, { forwardRef, memo, useEffect, useRef, useState } from 'react'
import { DS } from '../../design-system'
import DatePickerWeb from 'react-datepicker'

import 'react-datepicker/dist/react-datepicker.css'

import { translate } from '../../i18n'
import { ALLOWED_MINUTES_OFFSET, getNextMinimumValidDateTime } from '@ppwr/poker'
import { useStore } from '../../models'
import { TextInput } from 'react-native'

// biome-ignore lint/suspicious/noExplicitAny: <explanation>
const CustomInput = forwardRef((props: any, ref) => {
  return (
    <TextInput
      {...props}
      ref={ref}
      editable={false}
      style={{
        height: 48,
        backgroundColor: DS.palette['Global/White'],
        borderRadius: 5,
        paddingLeft: 16,
        paddingRight: 12,
        marginTop: 6,
        borderColor: DS.palette['Global/Black'],
        borderWidth: 1,
        width: '100%',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        ...DS.typography['Body Medium/Regular']
      }}
    />
  )
})

const DateTimePickersComp = () => {
  const {
    game: { setGameScheduledAt }
  } = useStore()

  const nextValidTime = getNextMinimumValidDateTime()
  const [date, setDate] = useState(nextValidTime)
  const inputRef = useRef(null)

  useEffect(() => {
    setGameScheduledAt(date)
  }, [date, setGameScheduledAt])

  useEffect(() => {
    const checkNextAvailableSchedule = () => {
      const now = new Date()
      const nextMinutes = Math.ceil(date.getTime() / (1000 * 60))
      const diff = Math.ceil(nextMinutes - now.getTime() / (1000 * 60))

      if (diff <= ALLOWED_MINUTES_OFFSET) {
        const nextValidDateTime = getNextMinimumValidDateTime()
        setDate(nextValidDateTime)
      }
    }

    checkNextAvailableSchedule()

    const intervalID = setInterval(() => {
      checkNextAvailableSchedule()
    }, 1000)

    return () => clearInterval(intervalID)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [date])

  return (
    <React.Fragment>
      <DS.Frame gap="8">
        <DS.Text variant="Body Medium/Medium" color="Global/Black">
          {translate('createTournamentScreen.date')}
        </DS.Text>
        <DatePickerWeb
          selected={date}
          onChange={(selectedDate) => selectedDate && setDate(selectedDate)}
          dateFormat={'EEE MMM d'}
          customInput={<CustomInput ref={inputRef} />}
        />
      </DS.Frame>

      <DS.Frame gap="8">
        <DS.Text variant="Body Medium/Medium" color="Global/Black">
          {translate('createTournamentScreen.time')}
        </DS.Text>
        <DatePickerWeb
          selected={date}
          onChange={(selectedDate) => selectedDate && setDate(selectedDate)}
          showTimeSelect
          showTimeSelectOnly
          timeIntervals={15}
          timeCaption="Time"
          dateFormat="h:mm aa"
          customInput={<CustomInput ref={inputRef} />}
        />
      </DS.Frame>
    </React.Fragment>
  )
}

export const DateTimePickers = memo(DateTimePickersComp)
